import React from 'react';
import { Filter, FilterOption } from './search_filters';
import FilterChip from './filter_chip';
import CoreLink from './core_link';
import { Location } from 'history';
import qs from 'qs';
import { MParticleEventName } from '../elog/mparticle_tracker';

interface IProps {
  filter: Filter;
  option: FilterOption;
  location: Location;
}

export default function DismissibleFilter({
  filter,
  option,
  location = null,
}: IProps) {
  const trackingData = {
    componentName: 'DismissibleFilter',
    eventName: MParticleEventName.ClickedDismissibleFilter,
    filter: filter.name,
    option: option.name,
  };

  const getDismissLink = () => {
    const dismissedParams = { [option.paramName]: option.unsetValues };

    return {
      pathname: location.pathname,
      query: {
        ...qs.parse(location.search, { ignoreQueryPrefix: true }),
        ...dismissedParams,
      },
    };
  };

  return (
    <>
      <CoreLink
        to={getDismissLink()}
        clickEvent={trackingData}
        className="mr-1 mb-1"
      >
        <FilterChip
          dismissible
        >
          {option.name}
        </FilterChip>
      </CoreLink>
    </>
  );
}
